/**
 * Отдать блоб браузеру как скачиваемый файл.
 *
 * Ссылку нельзя открыть обычным <a href>: эндпоинт требует заголовок Authorization,
 * а браузер по ссылке его не отправит. Поэтому файл забирается фетчем и скармливается
 * браузеру уже из памяти.
 *
 * @param {Blob} blob
 * @param {String} filename
 */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Освобождаем на следующем тике: часть браузеров не успевает начать скачивание,
  // если ссылку отозвать сразу после click().
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
